export default __webpack_public_path__ + "static/media/about-us-mob.1f528492.png";